<template>
  <div
    ref="chart"
    :class="hideToolbarClassName"
    style="height: 100%; width: 100%"
  />
</template>

<script>
import Plotly from 'plotly.js-cartesian-dist-min'

export default {
  name: 'LineChart',

  props: {
    data: [Object, Array], // { x: Array, y: Array }
    showLegend: {
      type: Boolean,
      default: false
    },
    xAxis: {
      type: Object,
      default: () => null
    },
    yAxis: {
      type: Object,
      default: () => null
    },
    margin: {
      type: Object,
      default: () => null
    },
    showSlider: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      required: false
    },
    hideToolbar: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    lineData () {
      if (Array.isArray(this.data)) {
        return this.data.map(dataTrace => this.createLineChartData(dataTrace))
      } else {
        return [this.createLineChartData(this.data)]
      }
    },

    lineLayout () {
      return {
        title: this.title || '',
        showlegend: this.showLegend,
        hoverlabel: { bgcolor: '#515a6e' },
        margin: this.margin ? {
          l: this.margin.l,
          r: this.margin.r,
          b: this.margin.b,
          t: this.margin.t
        } : null,
        xaxis: this.xAxis ? {
          title: this.xAxis.name,
          type: this.xAxis.type,
          automargin: true,
          rangeslider: { visible: this.showSlider },
          tickformat: this.xAxis.tickFormat || null,
          dtick: this.xAxis.tickStep || null,
          ticksuffix: this.xAxis.tickSuffix || null,
          zeroline: this.xAxis.zeroline || null
        } : {
          showticklabels: false,
          showline: false,
          zeroline: false,
          showgrid: false,
          fixedrange: true
        },
        yaxis: this.yAxis ? {
          autorange: true,
          title: this.yAxis.name,
          type: 'linear',
          automargin: true,
          zeroline: this.yAxis.zeroline || null,
          rangemode: this.yAxis.nonNegative ? 'nonnegative' : null
        } : {
          showticklabels: false,
          showline: false,
          zeroline: false,
          showgrid: false,
          fixedrange: true
        }
      }
    },

    hideToolbarClassName () {
      return this.hideToolbar ? 'hide-toolbar' : ''
    }
  },

  watch: {
    lineData: {
      handler () {
        this.loadChart()
      },
      deep: true
    },

    lineLayout: {
      handler () {
        this.loadChart()
      },
      deep: true
    }
  },

  mounted () {
    this.loadChart()
  },

  methods: {
    createLineChartData (data) {
      return {
        x: (data && data.x) || [],
        y: (data && data.y) || [],
        name: data.name || null,
        type: 'scatter',
        marker: {
          color: 'white',
          line: {
            color: data.color || 'green',
            width: 1
          }
        },
        line: {
          color: data.color || 'green'
        },
        text: (data && data.text) || [],
        hoverinfo: (data && data.text) ? 'text' : '',
        hoverlabel: { namelength: 0 }
      }
    },

    /**
     * Loads the line chart
     */
    loadChart () {
      const { chart } = this.$refs

      Plotly.newPlot(chart, this.lineData, this.lineLayout, { responsive: true })
    }
  }
}
</script>
<style scoped>
  .hide-toolbar >>> .modebar {
    display: none;
  }
</style>
